import _ from 'underscore';

class ManagementUserOrganizationMemberService {
  constructor($q, sdkOrganizationMemberService, managementUserService, organizationService) {
    this._$q = $q;
    this._sdkOrganizationMemberService = sdkOrganizationMemberService;
    this._organizationService = organizationService;
    this._managementUserService = managementUserService;
    this._currentOrganizationMember = null;
    this._currentOrganizationMembers = null;
  }

  clear() {
    this._currentOrganizationMembers = null;
    this._currentOrganizationMember = null;
  }

  /**
   * @desc Sets the inmemory version of the current organization member
   * @return {Object}
   */
  setCurrentOrganizationMember(organizationMember) {
    if (!organizationMember) throw new Error('organizationMemberService - setCurrentOrganizationMember() - organization is required');

    this._currentOrganizationMember = organizationMember;
  }

  /**
   * @desc Sets the inmemory version of the current organization members
   * @return {Object}
   */
  setCurrentOrganizationMembers(organizationMembers) {
    if (!organizationMembers) throw new Error('organizationMemberService - setCurrentOrganizationMembers() - organizationMembers is required');

    this._currentOrganizationMembers = organizationMembers;
  }

  /**
   * @desc Gets the inmemory version of the current organization member
   * @return {Object}
   */
  getCurrentOrganizationMember() {
    const currentOrganization = this._organizationService.getCurrentOrganization();

    if (!currentOrganization) throw new Error('getCurrentOrganizationMember() - currentOrganization must be set');
    if (this._currentOrganizationMember && this._currentOrganizationMember.organization === currentOrganization.id) return this._currentOrganizationMember;

    if (!this._currentOrganizationMembers || !this._currentOrganizationMembers.length) throw new Error('getCurrentOrganizationMember() - currentOrganizationMembers must be set');

    return _.findWhere(this._currentOrganizationMembers, {
      organization: currentOrganization.id
    });
  }

  /**
   * @desc Gets the inmemory version of the current organization member
   * @return {Object}
   */
  getCurrentOrganizationMembers() {
    const currentUser = this._managementUserService.getCurrentUser();

    if (!currentUser) throw new Error('organizationMemberService - getCurrentOrganizationMembers() - currentUser is required');

    if (this._currentOrganizationMembers) return this._$q.resolve(this._currentOrganizationMembers);

    return this._sdkOrganizationMemberService.listByManagementUserId(currentUser.id)
      .then(organizationMembers => {
        this.setCurrentOrganizationMembers(organizationMembers);

        return organizationMembers;
      });
  }
}

ManagementUserOrganizationMemberService.$inject = [
  '$q',
  'jsSdk.organizationMember',
  'jsSdk.managementUser',
  'organizationService'
];

export default ManagementUserOrganizationMemberService;



// WEBPACK FOOTER //
// ./src/services/managementUserOrganizationMemberService.js